<script>
export default {
  data() {
    return {
    }
  },
}
</script>
<template>
  <div>
    <h1>調價設定</h1>
  </div>
</template>
